const path = require('path')

const router = require('../../router')


module.exports = (graphql, actions, route) => {
  const { createPage } = actions
  const onboardingContainer = path.resolve('src/containers/Onboarding/index.js')

  return createPage({
    path: router(route.path, {}),
    component: onboardingContainer,
    context: {
      isVip: !!route.isVip,
    },
  })
}
